<template>
  <div class="mt-4">
    <input style="display: none;" ref="fileInput" type="file" @change="onFileSelected"/>
    <button class="capture-image" type="button" @click="openFileInput">
      <font-awesome-icon :icon="['fas', 'camera']"/>
    </button>
  </div>
</template>

<script>
  import ImageCompressor from 'image-compressor.js';
  import {qrcode} from '../qr_packed';

  export default {
    props: ['showCamera', 'from'],
    data() {
      return {
        video: {},
        canvas: {},
        imageNo: null,
        imageIndex: null,
        blob: '',
        allowedFormats: ['image/jpeg', 'image/png', 'image/jpg']
      };
    },
    methods: {
      openFileInput() {
        // this.$emit('setLoading', true);
        this.$refs.fileInput.value = '';
        this.$refs.fileInput.click();
      },
      async onFileSelected(e) {
        if (this.from === 'QRCODE') {
          this.$emit('setLoading', true);
          const that = this;
          var node = e.target;
          var reader = new FileReader();
          reader.onload = function () {
            node.value = '';
            qrcode.callback = function (res) {
              if (res instanceof Error) {
                that.$emit('setLoading', false);
                that.$toasted.show(that.$i18n.t('batteryData.qrCodeWasNotFound'));
              } else {
                // that.$toasted.show(res);
                that.$emit('sendPhoto', res);
              }
            };

            qrcode.decode(reader.result);
          };
          reader.readAsDataURL(node.files[0]);
        } else {

          const file = e.target.files[0];
          const fileType = e.target.files[0].type;

          if (!this.allowedFormats.some(format => format === fileType)) {
            this.$toasted.show(this.$i18n.t('Invalid file'));
            return;
          }
          if (!file) {
            return;
          }

          this.$emit('setLoading', false);
          this.$emit('sendPhoto', file);
        }
      },

      async transformFile(file) {
        const imageCompressor = new ImageCompressor();

        try {
          const result = await imageCompressor.compress(file, {
            maxWidth: 1920,
            maxHeight: 3840,
            minWidth: 3000,
            minHeight: 3000,
            quality: 0.8,
            mimeType: 'image/jpeg'
          });

          return result;
        } catch (err) {
          return false;
        }
      }
    }
  };
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

.capture-image {
  display: inline-block;
  border-radius: 20px;
  padding: 9px;
  color: $primary;
  background: #fff;
  width: 62px;
  height: 62px;
  bottom: 15px;
  font-size: 20px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 9;
  border: 1px solid $primary;
}
</style>
